import React from 'react';
import { ReactComponent as Logo } from 'svg/min-logo-white.svg';

import './style.css';

const Footer = () => {
  return (
    <>
      {/* <footer id="links">
        <p>
          <a href="/privacy-policy">Privacy Policy</a> | 
          <a href="/terms-generic">Website Terms</a> | 
          <a href="/terms-worker">Worker Terms</a> | 
          <a href="/terms-employer">Employer Terms</a>
        </p>
      </footer> */}
      <footer id="footer">
        <div className="wrapper">
          <div className="logo">
            <Logo />
            <pre>V. {process.env.REACT_APP_VERSION}</pre>
          </div>

          <div className="address">
            <p>
              My Shifts Ltd
              <br />
              Optima House,
              <br />
              100 Manchester Road,
              <br />
              Denton, Manchester M34 3PR
              <br />
              <a href="mailto:hello@my-shifts.co.uk">hello@my-shifts.co.uk</a>
            </p>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
